import React from 'react';
import { ZCDIcon, ZCDTable } from '@zencity/common-ui';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ExpandableTable from './ExpandableTable';
import SentimentBar from './SentimentBar';

const renderSentimentBar = (props) => {
  const { overAllSentimentCounts } = props;
  const total = Object.values(overAllSentimentCounts).reduce((acc, count) => acc + count, 0);
  const { positive, mixed, neutral, negative } = overAllSentimentCounts;
  const positivePercent = Number(((positive / total) * 100).toFixed(2));
  const mixedPercent = Number(((mixed / total) * 100).toFixed(2));
  const neutralPercent = Number(((neutral / total) * 100).toFixed(2));
  const negativePercent = Number(((negative / total) * 100).toFixed(2));

  return (
    <SentimentBar
      allowComment
      positive={positive}
      positivePercent={positivePercent}
      mixed={mixed}
      mixedPercent={mixedPercent}
      neutral={neutral}
      neutralPercent={neutralPercent}
      negative={negative}
      negativePercent={negativePercent}
    />
  );
};

const columnArray = [
  { header: '', accessorKey: 'label' },
  { header: 'Count', accessorKey: 'count' },
  { header: '%', accessorKey: 'percentage' },
  { header: 'Sentiment', accessorKey: 'sentiment', cell: ({ row }) => row.original.sentiment },
  {
    id: 'expander',
    header: () => {
      return <span>More</span>;
    },
    accessorKey: 'Expend',
    cell: ({ row }) =>
      row.getCanExpand() ? (
        <span
          {...{
            onClick: row.getToggleExpandedHandler(),
            style: {
              paddingLeft: `${row.depth * 2}rem`,
            },
          }}
        >
          {row.getIsExpanded() ? <ZCDIcon name="chevron-down" /> : <ZCDIcon name="chevron-right" />}
        </span>
      ) : null,
  },
];

const OverAllTableWithSentimentData = (props) => {
  const { overAllSentimentCounts, overAllCommentStatistic } = props;
  const { t } = useTranslation();

  const total = Object.values(overAllSentimentCounts).reduce((acc, count) => acc + count, 0);

  const tableData = [
    {
      label: 'Total',
      count: total,
      percentage: '100%',
      sentiment: renderSentimentBar({ overAllSentimentCounts }),
    },
  ];

  const renderTopWords = () => {
    const columns = [
      { Header: '#', accessor: 'position' },
      { Header: t('topKeywords.word'), accessor: 'word' },
      { Header: t('topKeywords.responses'), accessor: 'ndoc' },
      { Header: t('topKeywords.mentions'), accessor: 'nentry' },
    ];
    const statsData = overAllCommentStatistic.map((stat, index) => ({
      ...stat,
      position: index + 1,
    }));

    return (
      <div>
        <ZCDTable columnArray={columns} tableData={statsData} maxItemsLimit={10} />
      </div>
    );
  };

  return (
    <ExpandableTable
      data={tableData}
      columns={columnArray}
      renderSubComponent={renderTopWords}
      getRowCanExpand={() => true}
    />
  );
};

OverAllTableWithSentimentData.propTypes = {
  overAllCommentStatistic: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  overAllSentimentCounts: PropTypes.shape({}).isRequired,
};

export default OverAllTableWithSentimentData;
